import { useEffect } from "react";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import TickerPage from "./TickerPage";

const VALID_PANELS = ["overview", "financials", "compare", "filings", "ownership"];

export default function StockRouter() {
  const location = useLocation();
  const navigate = useNavigate();

  // Strip leading '/stocks/' and trailing slashes, then split
  const path = location.pathname.replace(/^\/stocks\/?/, "").replace(/\/$/, "");
  const parts = path.split("/").filter(Boolean);

  useEffect(() => {
    if (parts.length === 0) {
      navigate("/");
      return;
    }

    if (parts.length === 1) {
      // e.g. /stocks/AAPL -> Needs exchange resolution
      const ticker = parts[0];
      fetch(`/api/companies/resolve/${encodeURIComponent(ticker)}`)
        .then((res) => {
          if (!res.ok) throw new Error("Not found");
          return res.json();
        })
        .then((data) => {
          navigate(`/stocks/${data.exchange}/${data.ticker}/overview`, { replace: true });
        })
        .catch(() => {
          navigate(`/stocks/US/${ticker}/overview`, { replace: true });
        });
      return;
    }

    if (parts.length === 2) {
      // Could be /stocks/AAPL/overview OR /stocks/NYSE/AAPL
      const p1 = parts[0];
      const p2 = parts[1];

      if (VALID_PANELS.includes(p2.toLowerCase())) {
        // It's /stocks/{ticker}/{panel} -> Needs exchange resolution
        const ticker = p1;
        const panel = p2.toLowerCase();
        fetch(`/api/companies/resolve/${encodeURIComponent(ticker)}`)
          .then((res) => {
            if (!res.ok) throw new Error("Not found");
            return res.json();
          })
          .then((data) => {
            navigate(`/stocks/${data.exchange}/${data.ticker}/${panel}`, { replace: true });
          })
          .catch(() => {
            navigate(`/stocks/US/${ticker}/${panel}`, { replace: true });
          });
      } else {
        // It's /stocks/{exchange}/{ticker} -> Missing panel
        navigate(`/stocks/${p1}/${p2}/overview`, { replace: true });
      }
      return;
    }
  }, [parts.join("/"), navigate]);

  // If we have exactly 3 parts (/stocks/exchange/ticker/panel), we can safely render TickerPage!
  if (parts.length >= 3) {
    return (
      <Routes>
        <Route path=":exchange/:ticker/:panel" element={<TickerPage />} />
        <Route path=":exchange/:ticker" element={<TickerPage />} />
      </Routes>
    );
  }

  // Loading state while resolving
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 text-gray-400">
      <p>Resolving ticker...</p>
    </div>
  );
}
